<template>
	<div>
	  	<SubTopNav :title="title" :image="image" />
	  	<div class="careers content">
			<div>
				<div v-html="content"></div>
				<div :class="[(currentCareer) ? 'no-grid' : 'career-grid', 'animated', 'fadeIn']">
					<div v-for="(career, index) in careers.slice().reverse()" :key="index" class="career"  :id="'career-'+career.nid[0].value">
						<div @click="loadCareer(career)"><h2>{{ career.title[0].value }} <i class="fas fa-angle-double-right" style="font-size:12pt" v-show="currentCareer != career.nid[0].value"></i><i class="fas fa-angle-double-down" style="font-size:12pt" v-show="currentCareer == career.nid[0].value"></i></h2></div>
						<div v-show="currentCareer == career.nid[0].value" class="career-body animated fadeIn">
							<div class="profile-pic" v-if="career.field_profile_picture && career.field_profile_picture.length > 0"><img :src="career.field_profile_picture[0].url"></div>
							<div v-html="career.body[0].value"></div>
							<div>&nbsp;</div>
							<div>&nbsp;</div>
							<b-button @click="showModal({component:'WebformEmbedModal', title: career.title[0].value +' Application',footer: false, hideLogo: true, embedId: career.field_application_form[0].target_id })" variant="secondary" class="btn-lg" v-if="career.field_application_form && career.field_application_form[0] && career.field_application_form[0].target_id  && career.field_application_form[0].status && career.field_application_form[0].status == 'open'">Apply &raquo;</b-button>
							<div v-else><i><strong>Applications are currently closed</strong></i></div>
						</div>
					</div>
				</div>
			</div>		
	  	</div>
  	</div>
</template>
<script>
// @ is an alias to /src
	import { mapActions } from 'vuex' 
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "careers",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		currentCareer:null,
	  		careers: [],
	  		title:null
	  	}
	  },
	  methods: {
	  	async getCareersPage(){
	  		var type = "page"
	        var id = "32"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	          if (data[0].body.length > 0){
        		this.content = data[0].body[0].value
        	  }

        	  if (data[0].title[0].value){
        	  	this.title = data[0].title[0].value
        	  }
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
	          
	        }
	  	},
  		async getCareers(){
	  		var type = "career"
	        var id = "all"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	          this.careers = data

	          var alias = this.$route.hash

	          if (alias){
	          	alias = alias.replace('#', '/')
	          	var itemArray = this.careers.filter(item => {
	          	 	return (alias == item.path[0].alias)
	          	})

	          	if (itemArray.length > 0){
	          		var loadItem = itemArray[0]
	          		this.loadCareer(loadItem)
	          	}
	          }
	        }
  		},
  		loadCareer(career){

  			var careerId = '#career-'+career.nid[0].value

  			if (this.currentCareer == career.nid[0].value){
  				var path = this.$route.path
	  			history.pushState(
				    {},
				    null,
				    path
				)
  				this.currentCareer = null
  			} else {
  				var alias = career.path[0].alias.replace('/', '#')
	  			history.pushState(
				    {},
				    null,
				    this.$route.path + alias
				)
  				this.currentCareer = career.nid[0].value
  			}

  			setTimeout(function () { 
  				this.$scrollTo(careerId, 500, {xoffset: -300})
  			}.bind(this), 200)
  			
  			
  			
  			// console.log('nid', career.nid[0].value)
  			// window.scrollTo(0,0);

  		},
  		...mapActions(['showModal'])
	  },
	  mounted(){
	  	this.getCareersPage()
	  	this.getCareers()
	  }
	};
</script>
<style scoped>
	.careers{
		text-align:left;
		margin-left:5%;
	}

	.profile-pic{
		float:left;
		margin-right:25px;
		margin-bottom:25px;
	}

	.left-column{
		margin-bottom:25px;
	}

	.career{
		/*width:150px;
		height:150px;*/
		padding:0px 0px 30px 30px;
		text-transform:uppercase;
		font-weight:bold;
		border-left:1px solid #333;
		border-bottom:1px solid #333;
		margin-bottom:25px;
		/*display:inline-block;*/
	}

	.career h2{
		font-size:20px;
		font-weight:bold;
		padding:30px 0px 15px 0px;
		cursor:pointer;

	}

	.career-body{
		text-transform:none;
		xfont-size:15px !important;
		font-weight:normal;
		position:relative;
		xz-index:-5;
	}

	.current-career{
		background:rgba(255, 255, 255, 0.95);
		position:absolute;
		/*width:100%;
		height:100vh;*/
		top:0;
		left:0;
		right:0;
		min-height:200vh;
		height:100vh;
		padding:50px;
		text-align:left;
		z-index:500;
	}

	.close-icon{
		float:right;
		cursor:pointer;
		margin-right:-25px;
		margin-top:-25px;
	}

	.career:hover{
		xbackground:#FFFF00;
	}

	.position{
		font-family:"Tahoma", "Avenir", Helvetica, Arial, sans-serif;
		font-size:60%;
		font-weight:normal;
	}

	.career-grid{
		display:grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap:25px;
	}

	.page-image img{
		max-width:100%;
	}

	.page-image{
		background-size:cover;
	}

	.square{
		width:50%;
		overflow:hidden;
	}

	.square.blue{
		xclear:both;
		float:left;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
		float:right;
	}

	.square.yellow{
		background:rgba(255,255,0,0.8);
		clear:both;
		margin-bottom:20px;
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	}

	@media (max-width:768px){
		.career-grid{
			display:grid;
			grid-template-columns: 1fr;
			grid-gap:25px;
		}
	}


</style>
